$(document).ready(function () {
	// Dismissal persists for the browser session, keyed to the announcement
	// copy so a new campaign re-shows the bar. Skipped in the theme editor.
	if (window.Shopify && window.Shopify.designMode) return;

	const bar = document.querySelector(".section-announcement [data-bj-dismiss-key]");
	const DISMISS_KEY = bar
		? bar.getAttribute("data-bj-dismiss-key")
		: "bj-announcement-dismissed";

	const hideAnnouncement = (section) => {
		section.hide();
		document.body.classList.add("announcement-hide");
		document.documentElement.style.setProperty("--ann-height", "0px");
	};

	if (sessionStorage.getItem(DISMISS_KEY) === "1") {
		hideAnnouncement($(".section-announcement"));
	}

	if ($(".announcement-bar__close-button").length > 0) {
		let close_btns = $(".announcement-bar__close-button");

		close_btns.each((index, close_btn) => {
			let parent_section = $(close_btn).closest(".section-announcement");

			$(close_btn).on("click", () => {
				hideAnnouncement(parent_section);
				sessionStorage.setItem(DISMISS_KEY, "1");
			});
		});
	}
});
